module.exports = __webpack_public_path__ + "static/media/data2.ca962837.jpg";